import React, { useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { menu } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import { useCommon } from "../../../common/useCommon";
import { useAdmin } from "../useAdmin";
import { adminLogin, clearAdminToken } from "../../../common/adminSession";
import InfoMessage from "../../../components/InfoMessage/InfoMessage";

const Login = () => {
  useCommon();
  const history = useHistory();
  const [loginText, setLoginText] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { isLoggedIn, setIsLoggedIn } = useAdmin();

  // Checked on the server (Admin.Password in secrets.config), which issues the admin token.
  const tryLogin = async () => {
    setBusy(true);
    setError(null);
    const failure = await adminLogin(loginText);
    setBusy(false);
    if (failure) {
      setError(failure);
      return;
    }
    setLoginText("");
    setIsLoggedIn(true);
    history.push("/adminOrders");
  };

  const logout = () => {
    clearAdminToken();
    setIsLoggedIn(false);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="warning">
          <IonButtons slot="start">
            <IonMenuToggle>
              <IonIcon icon={menu} style={{ fontSize: 28 }} />
            </IonMenuToggle>
          </IonButtons>
          <IonTitle>Administracija</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="vertical-center" style={{ height: "80vh" }}>
          <IonGrid>
            <IonRow>
              <IonCol sizeMd="6" offsetMd="3">
                {!isLoggedIn && (
                  <IonList>
                    <IonItem>
                      <IonLabel color="medium" slot="end">
                        Admin Login
                      </IonLabel>
                      <IonInput
                        onIonInput={(e: any) => setLoginText(e.detail.value ?? "")}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && loginText.length > 0 && !busy) tryLogin();
                        }}
                        type="password"
                        value={loginText}
                      />
                    </IonItem>
                  </IonList>
                )}
                {!isLoggedIn && (
                  <IonButton
                    color="primary"
                    expand="block"
                    disabled={loginText.length === 0 || busy}
                    onClick={() => tryLogin()}
                  >
                    {busy ? <IonSpinner name="crescent" /> : "Login"}
                  </IonButton>
                )}
                {!isLoggedIn && error && <InfoMessage level="danger" text={error} />}
                {isLoggedIn && (
                  <IonButton color="danger" expand="block" onClick={logout}>
                    Logout
                  </IonButton>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Login;
